import { Button } from "@shared/antd/button";
import { Card } from "@shared/antd/card";
import React, { Component, ReactNode } from "react";
import { Collapse } from "antd";
import { CardProps } from "antd/lib/card";
import clsx from "clsx";

interface Props {
  title: string | ReactNode | Element;
  children: ReactNode;
  cardProps?: CardProps;
  panelKey?: string;
  sectionName?: string | React.ReactNode;
}

interface State {
  isCollapsed: boolean;
}

class CollapsibleCard extends Component<Props, State> {
  static defaultProps = {
    panelKey: "1",
    cardProps: {},
  };

  constructor(props: Props) {
    super(props);
    this.state = {
      isCollapsed: false,
    };
  }

  toggleCollapse = (e: React.MouseEvent) => {
    e.stopPropagation(); // Останавливаем всплытие события
    this.setState((prevState) => ({
      isCollapsed: !prevState.isCollapsed,
    }));
  };

  render() {
    const { isCollapsed } = this.state;
    const { title, children, cardProps, panelKey } = this.props;
    const baseClassName = clsx(
      "section-container lg:mx-10 lg:my-5 mb-6 lg:min-w-[93%] lg:max-w-[95.5%] section-container-small",
      cardProps.className,
    );

    return (
      <Card {...cardProps} className={baseClassName}>
        <Collapse className={"!bg-transparent"} bordered={false} activeKey={isCollapsed ? [] : [panelKey]}>
          <Collapse.Panel
            key={panelKey}
            header={
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
                onClick={this.toggleCollapse}
              >
                {this.props.sectionName || this.props.title ?
                  <div className="text-xl font-semibold text-primary-2">{typeof this.props.sectionName === "string" ?
                    <h2>{this.props.sectionName || this.props.title}</h2> : <>{this.props.sectionName || this.props.title}</>}</div> : <></>}
              </div>
            }
          >
            <>{children}</>
          </Collapse.Panel>
        </Collapse>
      </Card>
    );
  }
}

export default CollapsibleCard;
